import axios from "axios";
import { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { EmailChecklistContext } from "../../../context/EmailChecklistContext";
import { SaveTemplateContext } from "../../../context/SaveTemplateContext";
import { SignTypeContext } from "../../../context/SignTypeContext";
import { getSessionStorageValue } from "../../../service/getInfoSignatory";
import ArrowRight from "../../../svg/ArrowRight";
import Close from "../../../svg/Close";
import Help from "../../../svg/Help";
import {
  documentHeight,
  documentWidth,
} from "../../../utils/measuresForResponsiveness";
import Footer from "../../Footer";
import LoadingSpinner from "../../LoadingSpinner";
import { fields } from "../../Sign/CustomPDFViewer/data";
import Modal from "../Modal";
import { Signatories } from "../Section";
import {
  FooterButton,
  FooterButtonWrapper,
  FooterInfo,
  FooterWrapper,
  SectionModalSeq,
  SelectFooter,
  Wrapper,
} from "./styled";

interface FooterProps {
  urlDestination: string;
  signatoriesList: Signatories;
  modeSign: string;
}

const FooterPdf = ({ urlDestination, signatoriesList, modeSign }: FooterProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [help, setHelp] = useState<boolean>(false);
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [openModalSequential, setOpenModalSequential] = useState<boolean>(false);

  const { saveTemplate } = useContext(SaveTemplateContext);
  const { emailChecklist, setEmailChecklist } = useContext(
    EmailChecklistContext
  );
  const { setCurrentInputError, setSelectedOption } =
    useContext(SignTypeContext);

  const urlAssinando = process.env.REACT_APP_ASSINANDO;

  const urlID = window.location.search;
  const urlParams = new URLSearchParams(urlID);
  const idUrl = urlParams.get("id");
  const tokenAuth = urlParams.get("token");

  useEffect(() => {
    if (window.innerWidth <= 768) {
      Swal.fire({
        title: "Instruções para marcação",
        html: `Para colocar a marcação em tela: <br><br> <b>1.</b> Escolha a opção no menu esquerdo <br> <b>2.</b> Toque 2x no local que deseja marcar <br> <b>3.</b> Arraste para definir o posicionamento e o tamanho da marcação <br><br> ${
          modeSign === "sequential"
            ? "<b> A ordenação da sequencia das assinaturas será feita na próxima etapa</b>"
            : ""
        }`,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "info",
        timerProgressBar: true,
        didOpen: () => {
          setTimeout(() => {
            Swal.update({
              showConfirmButton: true,
              confirmButtonColor: "#77EC84",
            });
          }, 5000);
        },
        color: "#2c2c2c",
      });
    }
  }, [help, modeSign]);

  useEffect(() => {
    if (window.innerWidth > 768 && modeSign === "sequential") {
      Swal.fire({
        title: "Instruções para Marcação",
        html: "Como o modo de assinatura é sequencial, a ordenação das assinaturas será definida na próxima etapa.",
        showConfirmButton: false, // Oculta o botão inicialmente
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          setTimeout(() => {
        Swal.update({
          showConfirmButton: true, // Ativa o botão após 5s
          confirmButtonColor: "#77EC84",
        });
          }, 5000);
        },
        icon: "info",
        color: "#2c2c2c",
      });
    }
  }, [modeSign]);

  useEffect(() => {
    if (openConfirmation) {
      Swal.fire({
        title: "Confirmação de Envio",
        html: "Você tem certeza que deseja enviar as marcações?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#355b94",
        confirmButtonColor: "#77EC84",
        cancelButtonText:
          '<span style="color: #fff; font-size: 14px;">CANCELAR</span>',
        confirmButtonText:
          '<span style="color: #2c2c2c; font-size: 14px;">SIM, ENVIAR</span>',
        color: "#2c2c2c",
      }).then((result) => {
        if (result.isConfirmed) {
          handleSendSigns();
        } else {
          setOpenConfirmation(false);
        }
      });
    }
  }, [openConfirmation]);

  function generateRandomUUID() {
    const part1 = Math.floor(Math.random() * 0xffffffff);
    const part2 = Math.floor(Math.random() * 0xffffffff);
    const part3 = Math.floor(Math.random() * 0xffffffff);
    const part4 = Math.floor(Math.random() * 0xffffffff);

    const uuid = `${part1.toString(16).padStart(8, "0")}-${part2
      .toString(16)
      .padStart(8, "0")}-${part3.toString(16).padStart(8, "0")}-${part4
      .toString(16)
      .padStart(8, "0")}`;

    return uuid;
  }

  const identifyPageByY = (sign: Element) => {
    const y = parseFloat(sign.getAttribute("y") || "0");
    const page = Math.floor(y / documentHeight + 1);
    return page;
  };

  const getAllSigns = () => {
    const signs = document.querySelectorAll('[id*="rect-sign-Element-"]');
    const signArray = Array.from(signs);

    const uuid = generateRandomUUID();

    const signsAttributes = signArray.map((sign) => {
      const page = sign.getAttribute("pathLength");
      const pageByY = identifyPageByY(sign);
      if (
        !page ||
        !sign.getAttribute("x") ||
        !sign.getAttribute("y") ||
        !sign.getAttribute("y1") ||
        !sign.getAttribute("width") ||
        !sign.getAttribute("height")
      ) {
        const elementToReplace = document.getElementById(
          sign.getAttribute("id") as string
        );
        if (elementToReplace) {
          setCurrentInputError(elementToReplace.id);
          elementToReplace.style.fill = "#d81616";
          elementToReplace.scrollIntoView({
            block: "center",
            inline: "center",
          });
        }
        Swal.fire({
          title: "Verifique o campo!",
          html: `<div><p>O campo com <b>ID ${sign
            .getAttribute("id")
            ?.replace(
              "rect-sign-Element-",
              ""
            )}</b> na página <b>${pageByY}</b> não
          está posicionado corretamente.</p><p>Por favor, mova-o para uma nova
          posição e tente novamente.</p><p>Você será redirecionado para o campo.</p></div>`,
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#355B94",
          width: "575px",
          footer:
            "Caso o erro persista, entre em contato com o suporte: suporte@assinando.com.br",
          color: "#2c2c2c",
        });
        throw new Error();
      }

      return {
        id: uuid,
        page,
        x: sign.getAttribute("x"),
        y: sign.getAttribute("y"),
        y_relative: sign.getAttribute("y1"),
        width: sign.getAttribute("width"),
        height: sign.getAttribute("height"),
        color: sign.getAttribute("fill"),
        type: sign.getAttribute("type")?.split("-")[0],
        email: sign.getAttribute("class")?.replace("signature-", ""),
        text_label:
          sign.getAttribute("type")?.split("-")[0] === "text"
            ? sign.getAttribute("values")?.split("-")[0]
            : sign.getAttribute("type")?.split("-")[0] === "select"
            ? JSON.stringify(
                JSON.parse(sign.getAttribute("values") || "[]").filter(
                  (item: string) => item.trim() !== ""
                )
              )
            : sign.getAttribute("type")?.split("-")[0] === "cpf"
            ? "CPF"
            : sign.getAttribute("type")?.split("-")[0] === "cnpj"
            ? "CNPJ"
            : sign.getAttribute("type")?.split("-")[0] === "date"
            ? "Data"
            : "",
        select_name:
          sign.getAttribute("type")?.split("-")[0] === "select"
            ? sign.getAttribute("name")?.split("-")[0]
            : "",
      };
    });

    return signsAttributes;
  };

  const configObject = () => {
    try {
      const config = {
        template: {
          has_saved_template: !!saveTemplate,
          template_name: saveTemplate,
        },
        settings: {
          document_width: documentWidth,
          signatories: emailChecklist,
        },
        request: {
          uuid: idUrl,
        },
        fields: getAllSigns(),
      };
      const sortedSignatories = Object.entries(config.settings.signatories)
        .sort(([, a]: any, [, b]: any) => a.order - b.order)
        .reduce((acc, [email, data]) => {
          acc[email] = data;
          return acc;
        }, {} as typeof config.settings.signatories);

      config.settings.signatories = sortedSignatories;
      if (getAllSigns().length === 0 || fields.length === 0) {
        Swal.fire({
          title: "Atenção!",
          text: "Posicione um campo para enviar o documento!",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#355B94",
        });
        setOpenConfirmation(false);
        return {};
      } else {
        return config;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const sendRequesterSignature = async (jsonConfig: string, token: string) => {
    const url = process.env.REACT_APP_API_BASEURL;
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${url}/request-signature/${idUrl}/envelope?token=${tokenAuth}`,
        jsonConfig,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        setIsLoading(false);
        sessionStorage.clear();
        window.location.href = `${urlDestination}`;
      }
      return response.data;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };
  const modalSequential = () => {
    const handleSequenceChange = (email: string, sequence: number) => {
      setEmailChecklist((prevChecklist) => ({
        ...prevChecklist,
        [email]: {
          ...prevChecklist[email],
          order: sequence,
        },
      }));
    };

    const isSequenceValid = () => {
      const sequences = Object.values(emailChecklist).map((item) => item.order);
      const uniqueSequences = new Set(sequences);
      return (
        sequences.length === uniqueSequences.size &&
        sequences.length === signatoriesList.length &&
        sequences.every((seq) => seq > 0)
      );
    };

    const handleConclude = () => {
      if (!isSequenceValid()) {
        setOpenModalSequential(false);      
        Swal.fire({
          title: "Erro!",
          text: "Certifique-se de que todas as sequências estão preenchidas, iniciam com um número maior que 0 e não estão repetidas.",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#355B94",
        });
        return;
      }
      handleSendSigns();
    };

    return (
      <Modal isOpen={openModalSequential}>
        <SectionModalSeq>
          <h1>Sequência</h1>
          <h4>Selecione a sequência das assinaturas</h4>
          {signatoriesList.map((item, index) => (
            <Wrapper key={index}>
              <div>{item.email}:</div>
              <SelectFooter
                onChange={(e: any) =>
                  handleSequenceChange(item.email, parseInt(e.target.value))
                }
              >
                <option value="-1">-</option>
                {Array.from({ length: signatoriesList.length }, (_, i) => (
                  <option key={i} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </SelectFooter>
            </Wrapper>
          ))}
          <p>
            Ao clicar em "Confirmar", declaro que revisei e confirmei a
            sequência das assinaturas e que todas as marcações estão
            corretamente posicionadas no documento.
          </p>
          <FooterButtonWrapper padding="10px 0px 0px 0px">
            <FooterButton
              backgroundColor="#355b94"
              hoverBackgroundColor="#32568C"
              color="#fff"
              onClick={() => setOpenModalSequential(false)}
            >
              Voltar
            </FooterButton>
            <FooterButton
              backgroundColor="#77EC84"
              hoverBackgroundColor="#72E27F"
              color="#2c2c2c"
              onClick={handleConclude}
            >
              Concluir
            </FooterButton>
          </FooterButtonWrapper>
        </SectionModalSeq>
      </Modal>
    );
  };
  
  const handleSubmit = () => {
    const config = configObject();
    const jsonConfig = JSON.stringify(config);
    if (jsonConfig === undefined || jsonConfig.length === 2) {
      return;
    } else {
      if (modeSign === "sequential") {
        setOpenModalSequential(true);
      } else {
        setOpenConfirmation(true);
      }
      return jsonConfig;
    }
  };

  const handleSendSigns = async () => {
    const jsonConfig = handleSubmit();
    setSelectedOption("");    
    if (jsonConfig) {
      setIsLoading(true);
      try {
        const response = await sendRequesterSignature(
          jsonConfig,
          tokenAuth ?? ""
        );

        if (response.request) {
          Object.keys(sessionStorage).forEach(function (key) {
            sessionStorage.removeItem(key);
          });
        }
      } catch (error: any) {
        setIsLoading(false);
        Swal.fire({
          title: "Erro!",
          text: error.response.data.message || "Falha ao enviar dados!",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#44b1f3",
        });
        console.error("Erro ao enviar os dados Json:", error);
      }
    }
  };

  const deleteRequesterSignature = async () => {
    const url = process.env.REACT_APP_API_BASEURL;
    const token = getSessionStorageValue("token_user");
    try {
      setIsLoading(true);
      const response = await axios.delete(
        `${url}/service/request-signature/${idUrl}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        setIsLoading(false);
        window.location.href = `${urlAssinando}`;
      }
      return response.data;
    } catch (error) {
      setIsLoading(false);

      Swal.fire({
        title: "Erro!",
        text: "Falha ao enviar dados!",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#355B94",
      });
      return error;
    }
  };

  const handleDeleteSigns = async () => {
    try {
      const response = await deleteRequesterSignature();

      if (response.document) {
        Object.keys(sessionStorage).forEach(function (key) {
          sessionStorage.removeItem(key);
        });
      }
    } catch (error: any) {
      Swal.fire({
        title: "Erro!",
        text: error.errors.error || "Falha ao enviar dados!",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#355B94",
      });
      console.error("Erro ao enviar os dados Json:", error);
    }
  };

  const handleHelp = () => {
    setHelp(!help);
  };

  return (
    <>
      {isLoading && <LoadingSpinner />}
        {modalSequential()}
      <FooterWrapper>
        <FooterInfo isMobile={true}>
          Clique duas vezes na marcação para excluí-la!
          <div onClick={handleHelp}>
            <Help />
          </div>
        </FooterInfo>
        <FooterButtonWrapper padding="10px 20px">
          <FooterButton
            backgroundColor="#355b94"
            hoverBackgroundColor="#32568C"
            onClick={handleDeleteSigns}
          >
            <Close size="16" fill="#fff" />
            Cancelar e Voltar
          </FooterButton>
          <FooterInfo isMobile={false}>
            Clique duas vezes na marcação para excluí-la!
          </FooterInfo>
          <FooterButton
            backgroundColor="#77EC84"
            hoverBackgroundColor="#72E27F"
            color="#2c2c2c"
            onClick={handleSubmit}
          >
            Enviar
            <ArrowRight fill="#2c2c2c" />
          </FooterButton>{" "}
        </FooterButtonWrapper>

        <Footer isAbsolute={false} />
      </FooterWrapper>
    </>
  );
};

export default FooterPdf;
